function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChronometer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8C29"
    },
    d: "M446.261,110l-38.978-38.978c-1.49-1.49-3.513-2.328-5.621-2.328s-4.131,0.837-5.621,2.328 l-44.973,44.974c-3.105,3.106-3.105,8.139,0,11.244l38.978,38.977c1.49,1.49,3.513,2.328,5.621,2.328s4.131-0.837,5.621-2.328 l44.973-44.974C449.366,118.138,449.366,113.105,446.261,110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD1A9"
    },
    d: "M446.261,121.244c3.105-3.106,3.105-8.139,0-11.244l-38.978-38.978 c-1.49-1.49-3.513-2.328-5.621-2.328s-4.131,0.837-5.621,2.328l-7.22,7.221l50.221,50.222L446.261,121.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#687F82"
    },
    d: "M280.366,29.681h-33.921c-4.391,0-7.95,3.559-7.95,7.95v46.642c0,4.392,3.56,7.95,7.95,7.95h33.921 c4.391,0,7.95-3.559,7.95-7.95V37.631C288.316,33.24,284.757,29.681,280.366,29.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD4D5"
    },
    d: "M305.807,0h-84.803c-4.391,0-7.95,3.559-7.95,7.95v33.921c0,4.392,3.56,7.95,7.95,7.95h84.803 c4.391,0,7.95-3.559,7.95-7.95V7.95C313.757,3.559,310.198,0,305.807,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BAAAB"
    },
    d: "M221.004,0c-4.391,0-7.95,3.559-7.95,7.95v33.921c0,4.392,3.56,7.95,7.95,7.95h42.402V0H221.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M297.327,41.342c-4.391,0-7.95-3.559-7.95-7.95V16.431c0-4.392,3.56-7.95,7.95-7.95 s7.95,3.559,7.95,7.95v16.961C305.277,37.783,301.717,41.342,297.327,41.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6EAEA"
    },
    d: "M263.405,80.563c-118.947,0-215.718,96.771-215.718,215.718S144.458,512,263.405,512 s215.718-96.771,215.718-215.718S382.352,80.563,263.405,80.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD4D5"
    },
    d: "M47.687,296.282C47.687,415.229,144.458,512,263.405,512V80.563 C144.457,80.563,47.687,177.334,47.687,296.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ACFD9"
    },
    d: "M263.405,135.685c-88.554,0-160.596,72.044-160.596,160.596s72.043,160.596,160.596,160.596 s160.596-72.044,160.596-160.596S351.958,135.685,263.405,135.685z M263.405,394.335c-54.067,0-98.054-43.986-98.054-98.054 s43.986-98.054,98.054-98.054s98.054,43.986,98.054,98.054S317.473,394.335,263.405,394.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0295AA"
    },
    d: "M165.351,296.282c0-54.067,43.986-98.054,98.054-98.054v-62.542 c-88.554,0-160.596,72.044-160.596,160.596s72.043,160.596,160.596,160.596v-62.542 C209.338,394.335,165.351,350.349,165.351,296.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD6A33"
    },
    d: "M102.809,296.282v7.95h62.542v-7.95c0-54.067,43.986-98.054,98.054-98.054v-62.542 C174.851,135.685,102.809,207.729,102.809,296.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365558"
    },
    d: "M263.405,304.232c-2.034,0-4.069-0.776-5.621-2.328L164.5,208.62c-3.105-3.106-3.105-8.139,0-11.244 c3.105-3.104,8.139-3.104,11.243,0l93.284,93.284c3.105,3.106,3.105,8.139,0,11.244 C267.475,303.456,265.439,304.232,263.405,304.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#687F82"
    },
    d: "M263.405,241.689c-30.102,0-54.592,24.489-54.592,54.592s24.49,54.592,54.592,54.592 s54.592-24.49,54.592-54.592C317.997,266.18,293.507,241.689,263.405,241.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M288.846,304.232c-4.391,0-7.95-3.559-7.95-7.95c0-9.644-7.846-17.491-17.491-17.491 c-4.391,0-7.95-3.559-7.95-7.95s3.56-7.95,7.95-7.95c18.412,0,33.391,14.979,33.391,33.391 C296.796,300.673,293.237,304.232,288.846,304.232z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0353D"
    },
    d: "M40.822,189.75c-1.226,0-2.472-0.286-3.638-0.886c-3.902-2.013-5.434-6.809-3.422-10.711 c12.203-23.66,28.058-45.325,47.124-64.39c27.254-27.254,59.226-47.596,95.027-60.462c4.131-1.483,8.686,0.661,10.17,4.794 c1.485,4.131-0.661,8.685-4.794,10.17c-33.579,12.068-63.577,31.158-89.16,56.742c-17.903,17.902-32.786,38.235-44.236,60.434 C46.483,188.179,43.702,189.75,40.822,189.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0353D"
    },
    d: "M42.263,121.905c-1.787,0-3.585-0.599-5.069-1.83c-3.38-2.802-3.85-7.814-1.048-11.194 c24.549-29.623,54.078-53.962,87.765-72.344c3.856-2.103,8.685-0.684,10.787,3.172c2.103,3.854,0.684,8.683-3.172,10.787 c-31.91,17.41-59.882,40.467-83.138,68.53C46.816,120.924,44.548,121.905,42.263,121.905z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronometer2);
export default __webpack_public_path__ + "static/media/chronometer-2.376ba93608632239d37d086b1df33419.svg";
export { ForwardRef as ReactComponent };